<template>
  <div class="c_table_wrap">
    <table>
      <colgroup>
        <col width="200px;">
        <col width="">
      </colgroup>
      <tr>
        <td class="c_t_title">제목</td>
        <td>
          <div>
            <el-input v-model="title" maxlength="40" @input="parentChange('title', title)"></el-input>
            <div class="input_error">{{ validation.firstError('title') }}</div>
          </div>
        </td>
      </tr>
      <tr>
        <td class="c_t_title">이미지</td>
        <td>
          <div class="img_update">
            <div class="board_upload" @click="changeType('files')">
              <el-upload
                  class="avatar-uploader"
                  action=""
                  list-type="picture-card"
                  :show-file-list="false"
                  :file-list="files"
                  :auto-upload="false"
                  :on-change="onlyOnePhotoChange"
              >
                <img v-if="hasImage(files)" :src="files[0].url" class="avatar popup_img">
                <i v-else class="el-icon-plus avatar-uploader-icon popup_pc_img"></i>
              </el-upload>
              <div class="input_error pt0 pb0">Pc에서 노출되는 이미지입니다. 크기 394 x 434 에 최적화 되어있습니다.</div>
              <div class="input_error">{{ validation.firstError('files') }}</div>
            </div>
          </div>

          <div class="img_update_mobile ml20">
            <div class="board_upload" @click="changeType('filesM')">
              <el-upload
                  class="avatar-uploader"
                  :auto-upload="false"
                  action=""
                  :show-file-list="false"
                  list-type="picture-card"
                  :file-list="filesM"
                  :on-change="onlyOnePhotoChange"
              >
                <img v-if="hasImage(filesM)" :src="filesM[0].url" class="avatar popup_img_mobile">
                <i v-else class="el-icon-plus avatar-uploader-icon popup_mobile_img"></i>
              </el-upload>
              <div class="input_error pt0 pb0">Mobile에서 노출되는 이미지입니다. 크기 650 x 860 에 최적화 되어있습니다.</div>
              <div class="input_error">{{ validation.firstError('filesM') }}</div>
            </div>
          </div>

        </td>
      </tr>
      <tr>
        <td class="c_t_title">상태</td>
        <td>
          <el-radio-group v-model="isDisplay" @change="parentChange('isDisplay', isDisplay)">
            <el-radio :label="1">사용</el-radio>
            <el-radio :label="0">미사용</el-radio>
          </el-radio-group>
        </td>
      </tr>
      <tr>
        <td class="c_t_title">노출기간</td>
        <td class="">
          <div class="filter-select-div el-filter-date pt0 pb0">

                        <span class="filter-select-div el-filter-date">
                        <span class="el-date-icon-img"></span>
                        <el-date-picker
                            v-model="displayRange"
                            type="daterange"
                            range-separator=""
                            value-format="yyyy-MM-dd"
                            start-placeholder="시작날짜"
                            end-placeholder="끝 날짜"
                            @change="changeDisplayDate(displayRange)"
                            class="el-date-common"
                            prefix-icon=" "
                            clear-icon="el-icon-circle-close el-clear-icon"
                        ></el-date-picker>
                        </span>
          </div>
        </td>
      </tr>
      <tr>
        <td class="c_t_title">내용</td>
        <td>
          <div>
            <el-input type="textarea" id="content" v-model="content" rows="10"
                      @input="parentChange('content', content)"></el-input>
            <div class="input_error">{{ validation.firstError('content') }}</div>
          </div>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import popupValidators from "@/mixins/validators/popupValidators";
import elFileMixins from "@/mixins/elFileMixins";
import util from "@/mixins/util";
import summernote from "@/mixins/summernote";
import imageOption from "../../../mixins/imageOption";
export default {
  name: "PopupWriteDefaultLayout",
  mixins: [popupValidators, elFileMixins, summernote],
  components: {},
  inject: ['popupWriteSetData'],
  provide() {
    return {}
  },
  props: {
    popupData: {},
  },
  data() {
    return {
      isDisplay: 1,
    }
  },
  created() {
    this.parentChange('isDisplay', this.isDisplay)
  },
  mounted() {

    this.initSummernote('content', '내용', 'content');
    this.initData();
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  computed: {},
  methods: {
    initData() {
      if (util.isEmpty(this.popupData)) {
        return false;
      }
      this.title = this.popupData.p_title;
      this.parentChange('title', this.title);
      this.isDisplay = this.popupData.p_is_display;
      this.parentChange('p_is_display', this.isDisplay);
      this.content = this.popupData.p_content;
      this.content = util.htmlDecode(this.content);
      this.parentChange('content', this.content);
      $('#content').summernote('code', this.content);
      if (util.isEmpty(this.popupData.p_start) || util.isEmpty(this.popupData.p_end)) {
        this.displayRange = []
      } else {
        this.displayRange = [this.popupData.p_start.split(' ')[0], this.popupData.p_end.split(' ')[0]]
        this.changeDisplayDate(this.displayRange);
      }
      if (!util.isEmpty(this.popupData.File)) {
        this.popupData.File[0].url = this.popupData.File[0].org_url;
        this.files = this.popupData.File;
        this.parentChange('files', this.files);
      }

      if (!util.isEmpty(this.popupData.MobileFile)) {
        this.popupData.MobileFile[0].url = this.popupData.MobileFile[0].org_url;
        this.filesM = this.popupData.MobileFile
        this.parentChange('filesM', this.filesM);
      }

    },
    parentChange(key, value) {
      this.popupWriteSetData(key, value);
    },
    hasImage(files) {
      return !util.isEmpty(files);
    },
    changeDisplayDate(date) {
      if (util.isEmpty(date)) {
        this.displayStart = '';
        this.displayEnd = '';
      } else {
        this.displayStart = date[0]
        this.displayEnd = date[1]
      }
      this.parentChange('displayStart', this.displayStart)
      this.parentChange('displayEnd', this.displayEnd)
    },

  },
  watch: {
    'content': {
      deep: true,
      handler: function (val, oldVal) {
        console.log(this.content);
        this.parentChange('content', this.content)
      },
    }
  },
}
</script>

<style scoped>

</style>
